import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserApiReviewRepository } from './domain/UserApiReviewRepository'

import { ReviewListViewsQueryCriteria, UserReviewInListViews } from '../../contracts/review'
import { AxiosErrorHandler, SupernovaPagedBody, SupernovaPagedResponse } from '../../foundation'

export class UserApiReview implements UserApiReviewRepository {
  private errorHandler: AxiosErrorHandler

  constructor(private axios: AxiosInstance) {
    this.errorHandler = new AxiosErrorHandler()
  }

  getReviewList = async (
    criteria: ReviewListViewsQueryCriteria,
  ): Promise<SupernovaPagedBody<UserReviewInListViews[]>> => {
    const config: AxiosRequestConfig<ReviewListViewsQueryCriteria> = {
      url: '/review/query/user/get-review-list-views/process',
      method: 'post',
      data: criteria,
    }

    try {
      const { data } = await this.axios.request<SupernovaPagedResponse<UserReviewInListViews[]>>(config)

      return data.body
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
